import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { ReviewToggle } from '@app/mobile/driver-safety/list.component';

export type ITopbarState = 'hidden' | 'visible';

const classToHideTopbar: string = 'has-hidden-top-bar';

@Injectable()
export class TopBarService {
  public readonly topbarAvailbility$: Subject<boolean> = new Subject<boolean>(); // hides topbar and replaces it with page header
  private topbarState: BehaviorSubject<ITopbarState>;
  private topbarState$: Observable<ITopbarState>;
  private readonly backLink$: Subject<string> = new Subject<string>();
  private readonly ktAppElement: HTMLElement; // hides topbar and don't replaces it with anything
  private backLinkParams: ReviewToggle;

  constructor() {
    this.ktAppElement = document.querySelector('kt-app');
    this.initializeEmitters();
  }

  public setBackLink(link: string): void {
    this.backLink$.next(link);
  }

  public getBackLink$(): Observable<string> {
    return this.backLink$.asObservable();
  }

  public setBackLinkParams(params: ReviewToggle): void {
    this.backLinkParams = params;
  }

  public getBackLinkParams(): ReviewToggle {
    return this.backLinkParams;
  }

  public resetBackLink(): void {
    this.backLink$.next(null);
  }

  public showTopbar(): void {
    if (!this.ktAppElement) return;
    this.ktAppElement.classList.remove(classToHideTopbar);
  }

  public hideTopbar(): void {
    if (!this.ktAppElement) return;
    this.ktAppElement.classList.add(classToHideTopbar);
  }

  public get stateListener(): Observable<ITopbarState> {
    return this.topbarState$;
  }

  public setState(state: ITopbarState): void {
    this.topbarState.next(state);
  }

  public removeTopbar(shouldRemoveTopbar: boolean = true): void {
    this.topbarAvailbility$.next(shouldRemoveTopbar);
  }

  private initializeEmitters(): void {
    this.topbarState = new BehaviorSubject(null);
    this.topbarState$ = this.topbarState.pipe(
      distinctUntilChanged(),
      filter(val => Boolean(val)),
    );
  }
}
